import React from "react";
import styled from "styled-components";
import { gettext } from "utils/text";

import { gray100, lightBlue } from "~/styles/theme/color";

interface User {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  lastLogin?: string | null;
}

interface GroupUsersProps {
  members: readonly User[];
  loading: boolean;
}

const GroupUsers = ({ members, loading }: GroupUsersProps) => {
  const formatDate = (dateString?: string | null) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString();
  };

  return (
    <TableContainer>
      <StyledTable className="table mb-3">
        <thead>
          <tr>
            <th style={{ textAlign: "left", width: "25%" }}>
              {gettext("First Name")}
            </th>
            <th style={{ textAlign: "left", width: "25%" }}>
              {gettext("Last Name")}
            </th>
            <th style={{ textAlign: "left", width: "30%" }}>
              {gettext("Email")}
            </th>
            <th style={{ textAlign: "left", width: "20%" }}>
              {gettext("Last Logged In")}
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr className="skeleton">
              <td colSpan={4}>
                <div className="d-flex justify-content-center py-2">
                  <b>{gettext("Loading...")}</b>
                </div>
              </td>
            </tr>
          )}
          {!loading && members.length === 0 && (
            <tr className="skeleton">
              <td colSpan={4}>
                <div className="d-flex justify-content-center py-2">
                  <b>{gettext("No users found.")}</b>
                </div>
              </td>
            </tr>
          )}
          {!loading &&
            members.map((member) => (
              <tr key={member.id}>
                <td style={{ textAlign: "left" }}>{member.firstName || "-"}</td>
                <td style={{ textAlign: "left" }}>{member.lastName || "-"}</td>
                <td style={{ textAlign: "left" }}>{member.email || "-"}</td>
                <td style={{ textAlign: "left" }}>
                  {formatDate(member.lastLogin)}
                </td>
              </tr>
            ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

const TableContainer = styled.div`
  min-height: 300px;
`;

const StyledTable = styled.table`
  border: 0 !important;
  min-width: 100%;
  font-size: 0.875rem;
  border-collapse: separate;
  border-spacing: 0 5px;

  th,
  td {
    padding: 0.5rem;
  }

  thead tr {
    background-color: ${lightBlue};
    max-height: 40px;
    height: 40px;
  }

  && thead tr th {
    height: 40px;
    border-color: ${lightBlue};
  }

  && tbody tr {
    background-color: white;
    border: 1px solid ${gray100};

    td {
      border-color: ${gray100};
    }

    & td:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    & td:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  && tbody tr.skeleton {
    background-color: transparent;
    border: none;
  }
`;

export default GroupUsers;
